import { client } from "../utils/netlify";
import { setCookie, getCookie } from "cookies-next";
import { reportError } from "./errorHelper";
/*
 * @param request - line items ids to be removes
 */

const getStatusData = {
    1: {
        "stepId": "1",
        "step": "Active account init",
        "status": "process",
    },
    2: {
        "stepId": "2",
        "step": "Active account mail sent",
        "status": "success",
    },
    3: {
        "stepId": "3",
        "step": "Active account mail failed",
        "status": "error",
    },
    4: {
        "stepId": "4",
        "step": "Active page open",
        "status": "process",
    },
    5: {
        "stepId": "5",
        "step": "Active page error",
        "status": "error",
    },
    0: {
        "stepId": "0",
        "step": "Account activated",
        "status": "success",
    }
}

export const activeAccountLog = async (data) => {
    if (!process.env.ACTIVE_ACCOUNT_LOG || process.env.ACTIVE_ACCOUNT_LOG != 'ON') {
        return;
    }
    try {
        let resp;
        let stepId = data.stepId;
        let request = getStatusData[stepId];
        if (data.message)
            request.message = data.message;
        request.customerId = data.customerId;
        resp = await client("activate-user-log", request);
        return resp;
    } catch (err) {
        reportError("activeAccountLog function error")
        reportError(err)
        return {}
    }
};